module.exports = __webpack_public_path__ + "img/share.a46a0cc0.svg";